$(document).ready(function(){

    const eventDataNode = $("#risks__data");
    const risksForm = $('.risks--form')

    $('.js-disable-enter').on('keydown', function(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    })

    $('.button--risks').on('click', function (e) {
        e.preventDefault();
        // const path =  risksForm.attr('action');
        const year = parseInt(eventDataNode.val().split('.').pop())

        if ($("#risks__data").inputmask("isComplete") && !isNaN(year) && year.toString().length === 4 && isValidDate(eventDataNode.val())) {
            $.ajax({
                type: 'POST',
                url: '/ajax/check-disability',
                data: {
                    'date': eventDataNode.val(),
                },
                dataType: "json",
                beforeSend: function () {
                    eventDataNode.attr('readonly', true);
                    $('.button--risks').addClass('button--in-active');
                },
                success: function (data) {
                    eventDataNode.attr('readonly', false);
                    $('.button--risks').removeClass('button--in-active');

                    if (data === 1) {
                        $('.number__error--risks-data').text('Указана не верная дата').show();
                    }else if (data === 2) {
                        // risksForm.submit();
                        $('.number__error--risks-data').text('Заявление на эту дату уже подавалось').show();
                    } else if (data.error) {
                        // risksForm.submit();
                        $('.number__error--risks-data').text(data.error).show();
                    } else {
                        risksForm.submit();
                    }
                },
                errors: function (errors) {
                    console.log(errors);
                }
            });
            // if (checkDataPeriod(eventDataNode.val(), '01.01.2000', getTodayDateInISOFormat())) {
            //     location.href = path;
            // } else {
            //     $('.number__error--risks-data').text('Указана не верная дата').show();
            // }

        } else {
            $('.number__error--risks-data').text('Укажите дату страхового случая').show();
        }
    });

    $('#risks__data').on('input', function () {
        $('.number__error--risks-data').hide();
    });

    $("#risks__data").inputmask("99.99.9999");

    // const Api = new apiCommon();
    //
    // Api.sendSomeData('someData').then((res) => {
    //     console.log(res)
    // });
    //
    // Api.getSomeData('someParams').then((res) => {
    //     console.log(res)
    // });
});

